export const createClearStatusMap = (
  setShowSuccessNotification: (show: boolean) => void,
  setShowErrorNotification: (show: boolean) => void,
): Record<'success' | 'error', () => void> => ({
  success: () => setShowSuccessNotification(false),
  error: () => setShowErrorNotification(false),
});

export const PROFILE_PAGE_DATA_HOOKS = {
  MOBILE_PROFILE_PAGE: 'mobile-profile-page',
  PROFILE_PAGE: 'profile-page',
  PROFILE_PAGE_CONTAINER: 'profile-page-container',
  LEFT_PANEL: 'left-panel',
  PROFILE_PAGE_SECTIONS: 'profile-page-sections',
} as const;

export const PAGE_NAMES = {
  PROFILE_PAGE: 'profile page',
  NOT_FOUND_PAGE: 'not found page',
} as const;
